import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MessageCircle } from "lucide-react";
import { useLang } from "../i18n/LanguageContext";

const Footer = () => {
  const { tr, lp } = useLang();
  return (
    <footer className="bg-ink text-slate-300 mt-24">
      <div className="max-w-7xl mx-auto px-6 py-16 grid gap-10 md:grid-cols-4">
        <div>
          <div className="flex items-center gap-2 mb-4">
            <span className="w-10 h-10 rounded-2xl bg-white text-brand grid place-items-center font-heading font-extrabold text-lg">M</span>
            <span className="font-heading font-extrabold text-2xl text-white">MobiRider</span>
          </div>
          <p className="text-base leading-relaxed text-slate-400">{tr.footer.tagline}</p>
        </div>
        <div>
          <h4 className="text-white font-heading font-bold text-lg mb-4">{tr.footer.company}</h4>
          <ul className="space-y-2 text-base">
            <li><Link to={lp("/a-propos")} className="hover:text-white">{tr.nav.about}</Link></li>
            <li><Link to={lp("/comment-ca-marche")} className="hover:text-white">{tr.nav.how}</Link></li>
            <li><Link to={lp("/destinations")} className="hover:text-white">{tr.nav.destinations}</Link></li>
            <li><Link to={lp("/tarifs")} className="hover:text-white">{tr.nav.pricing}</Link></li>
            <li><Link to={lp("/faq")} className="hover:text-white">{tr.nav.faq}</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="text-white font-heading font-bold text-lg mb-4">{tr.footer.legal}</h4>
          <ul className="space-y-2 text-base">
            <li><Link to={lp("/cgv")} className="hover:text-white">{tr.footer.cgv}</Link></li>
            <li><Link to={lp("/confidentialite")} className="hover:text-white">{tr.footer.privacy}</Link></li>
            <li><Link to={lp("/mentions-legales")} className="hover:text-white">{tr.footer.mentions}</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="text-white font-heading font-bold text-lg mb-4">{tr.nav.contact}</h4>
          <ul className="space-y-3 text-base">
            <li><a href="tel:+33788041772" className="flex items-center gap-2 hover:text-white"><Phone className="w-5 h-5" /> 07 88 04 17 72</a></li>
            <li><a href="https://wa.me/33788041772" className="flex items-center gap-2 hover:text-white"><MessageCircle className="w-5 h-5" /> WhatsApp</a></li>
            <li><a href="mailto:thibault.milhaud@gmail.com" className="flex items-center gap-2 hover:text-white"><Mail className="w-5 h-5" /> thibault.milhaud@gmail.com</a></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10 py-6 text-center text-sm text-slate-500">
        © {new Date().getFullYear()} MobiRider. {tr.footer.rights}
      </div>
    </footer>
  );
};

export default Footer;
